/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

import React from 'react'
import '@fortawesome/fontawesome-svg-core/styles.css'
import { ThemeProvider } from 'styled-components'
import GlobalStyles from './src/components/GlobalStyles'
import MailingListSubscribeBarState from './src/context/MailingListSubscribeBarState'
import theme from './src/themes/default'

export const wrapRootElement = ({ element }) => {
  return (
    <MailingListSubscribeBarState.ProviderWithState>
      <ThemeProvider theme={theme}>{element}</ThemeProvider>
    </MailingListSubscribeBarState.ProviderWithState>
  )
}

export const wrapPageElement = ({ element }) => {
  return (
    <>
      <GlobalStyles />
      {element}
    </>
  )
}
